import React, { useState, useCallback, useMemo, useEffect, useRef } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import SessionManager from "./Utils/SessionManager";
import myToast from "./Utils/MyToast";
import COLORS from "./resources/colors/COLORS";

// Created By Cursor — read CRM App Access params from hash (preferred) or query, then scrub URL
function readAndClearCrmLoginParams() {
  const hashRaw = (window.location.hash || "").replace(/^#/, "");
  const hashParams = hashRaw ? new URLSearchParams(hashRaw) : null;
  const queryParams = new URLSearchParams(window.location.search || "");
  const params =
    hashParams && hashParams.get("crmlogin") === "1" ? hashParams : queryParams;

  if (params.get("crmlogin") !== "1") return null;

  const payload = {
    user_id: (params.get("user_id") || "").trim(),
    password: params.get("password") || "",
    school_code: (params.get("school_code") || "").trim(),
  };

  // Remove credentials from address bar immediately
  if (window.history && window.history.replaceState) {
    window.history.replaceState(null, "", window.location.pathname);
  } else {
    window.location.hash = "";
  }

  return payload;
}

const LOGIN_TYPES = {
  ADMIN: process.env.REACT_APP_LOGIN_TYPE_ADMIN,
  CLERK: process.env.REACT_APP_LOGIN_TYPE_CLERK,
  TEACHER: process.env.REACT_APP_LOGIN_TYPE_TEACHER,
  STUDENT: process.env.REACT_APP_LOGIN_TYPE_STUDENT,
};

const API_ENDPOINT = "staffLogin.php?";

const ACCENT = COLORS.primary_color_shade6;
const ACCENT_DARK = COLORS.primary_color_shade8;
const ACCENT_SOFT = COLORS.primary_color_shade0;

//Created By Cursor
function LoginInfographic() {
  return (
    <svg
      viewBox="0 0 560 520"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{ width: "100%", maxWidth: 520, height: "auto", display: "block" }}
    >
      <defs>
        <linearGradient id="igSky" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#E1F5FE" />
          <stop offset="55%" stopColor="#B3E5FC" />
          <stop offset="100%" stopColor="#81D4FA" />
        </linearGradient>
        <linearGradient id="igCard" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="100%" stopColor="#F8FBFF" />
        </linearGradient>
        <linearGradient id="igBar1" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#0288D1" />
          <stop offset="100%" stopColor="#4FC3F7" />
        </linearGradient>
        <linearGradient id="igBar2" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#00AA8D" />
          <stop offset="100%" stopColor="#5EEAD4" />
        </linearGradient>
        <linearGradient id="igBar3" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#FF8F00" />
          <stop offset="100%" stopColor="#FFCA28" />
        </linearGradient>
        <filter id="igSoft" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="10" stdDeviation="12" floodColor="#01579B" floodOpacity="0.12" />
        </filter>
      </defs>

      {/* Soft backdrop blob */}
      <ellipse cx="290" cy="270" rx="230" ry="190" fill="url(#igSky)" opacity="0.55" />
      <circle cx="90" cy="80" r="36" fill="#FFF" opacity="0.35" />
      <circle cx="480" cy="70" r="22" fill="#FFF" opacity="0.4" />
      <circle cx="500" cy="420" r="48" fill="#029BE5" opacity="0.12" />

      {/* Main dashboard card */}
      <g filter="url(#igSoft)" className="eduok-ig-float-a">
        <rect x="90" y="110" width="320" height="250" rx="22" fill="url(#igCard)" stroke="#D6E6F5" strokeWidth="1.5" />
        <text x="114" y="148" fill="#01579B" fontFamily="Outfit, sans-serif" fontSize="15" fontWeight="700">
          School Overview
        </text>
        <text x="114" y="168" fill="#64748B" fontFamily="Source Sans 3, sans-serif" fontSize="11">
          Live academic snapshot
        </text>

        {/* Mini KPI chips */}
        <rect x="114" y="186" width="86" height="42" rx="10" fill="#E1F5FE" />
        <text x="126" y="204" fill="#0288D1" fontFamily="Outfit, sans-serif" fontSize="10" fontWeight="700">Students</text>
        <text x="126" y="220" fill="#01579B" fontFamily="Outfit, sans-serif" fontSize="14" fontWeight="800">1,248</text>

        <rect x="210" y="186" width="86" height="42" rx="10" fill="#E0F7F1" />
        <text x="222" y="204" fill="#008975" fontFamily="Outfit, sans-serif" fontSize="10" fontWeight="700">Attendance</text>
        <text x="222" y="220" fill="#00695C" fontFamily="Outfit, sans-serif" fontSize="14" fontWeight="800">94.6%</text>

        <rect x="306" y="186" width="82" height="42" rx="10" fill="#FFF8E1" />
        <text x="318" y="204" fill="#FF8F00" fontFamily="Outfit, sans-serif" fontSize="10" fontWeight="700">Collected</text>
        <text x="318" y="220" fill="#E65100" fontFamily="Outfit, sans-serif" fontSize="14" fontWeight="800">₹8.2L</text>

        {/* Bar chart */}
        <rect x="130" y="300" width="28" height="36" rx="6" fill="url(#igBar1)" />
        <rect x="176" y="276" width="28" height="60" rx="6" fill="url(#igBar2)" />
        <rect x="222" y="288" width="28" height="48" rx="6" fill="url(#igBar3)" />
        <rect x="268" y="262" width="28" height="74" rx="6" fill="url(#igBar1)" />
        <rect x="314" y="248" width="28" height="88" rx="6" fill="url(#igBar2)" />
        <text x="130" y="350" fill="#94A3B8" fontFamily="Source Sans 3, sans-serif" fontSize="10">Mon</text>
        <text x="178" y="350" fill="#94A3B8" fontFamily="Source Sans 3, sans-serif" fontSize="10">Tue</text>
        <text x="224" y="350" fill="#94A3B8" fontFamily="Source Sans 3, sans-serif" fontSize="10">Wed</text>
        <text x="270" y="350" fill="#94A3B8" fontFamily="Source Sans 3, sans-serif" fontSize="10">Thu</text>
        <text x="318" y="350" fill="#94A3B8" fontFamily="Source Sans 3, sans-serif" fontSize="10">Fri</text>
      </g>

      {/* Floating attendance ring card */}
      <g filter="url(#igSoft)" className="eduok-ig-float-b">
        <rect x="360" y="70" width="150" height="150" rx="20" fill="#FFF" stroke="#D6E6F5" strokeWidth="1.5" />
        <text x="378" y="98" fill="#334155" fontFamily="Outfit, sans-serif" fontSize="12" fontWeight="700">
          Today Present
        </text>
        <circle cx="435" cy="155" r="38" stroke="#E2E8F0" strokeWidth="10" fill="none" />
        <circle
          cx="435"
          cy="155"
          r="38"
          stroke="#03A9F4"
          strokeWidth="10"
          fill="none"
          strokeLinecap="round"
          strokeDasharray="190"
          strokeDashoffset="28"
          transform="rotate(-90 435 155)"
        />
        <text x="435" y="152" textAnchor="middle" fill="#01579B" fontFamily="Outfit, sans-serif" fontSize="18" fontWeight="800">
          92%
        </text>
        <text x="435" y="170" textAnchor="middle" fill="#64748B" fontFamily="Source Sans 3, sans-serif" fontSize="10">
          on campus
        </text>
      </g>

      {/* Floating fee due card */}
      <g filter="url(#igSoft)" className="eduok-ig-float-c">
        <rect x="40" y="300" width="170" height="110" rx="18" fill="#FFF" stroke="#D6E6F5" strokeWidth="1.5" />
        <text x="58" y="330" fill="#334155" fontFamily="Outfit, sans-serif" fontSize="12" fontWeight="700">
          Fee Progress
        </text>
        <rect x="58" y="348" width="134" height="10" rx="5" fill="#E2E8F0" />
        <rect x="58" y="348" width="96" height="10" rx="5" fill="#00AA8D" />
        <text x="58" y="380" fill="#008975" fontFamily="Outfit, sans-serif" fontSize="13" fontWeight="800">
          72% settled
        </text>
        <text x="58" y="396" fill="#94A3B8" fontFamily="Source Sans 3, sans-serif" fontSize="10">
          This academic session
        </text>
      </g>

      {/* Floating exam card */}
      <g filter="url(#igSoft)" className="eduok-ig-float-d">
        <rect x="340" y="360" width="180" height="100" rx="18" fill="#FFF" stroke="#D6E6F5" strokeWidth="1.5" />
        <rect x="358" y="380" width="36" height="36" rx="10" fill="#FFF3E0" />
        <path d="M370 388h12v4h-12zm0 8h12v4h-12zm0 8h8v4h-8z" fill="#FF8F00" />
        <text x="406" y="394" fill="#334155" fontFamily="Outfit, sans-serif" fontSize="12" fontWeight="700">
          Unit Test
        </text>
        <text x="406" y="412" fill="#64748B" fontFamily="Source Sans 3, sans-serif" fontSize="11">
          Classes I – VIII
        </text>
        <text x="358" y="440" fill="#0288D1" fontFamily="Outfit, sans-serif" fontSize="11" fontWeight="700">
          Scheduled · 24 Jul
        </text>
      </g>

      {/* Small people / students motif */}
      <g opacity="0.95">
        <circle cx="250" cy="430" r="14" fill="#4FC3F7" />
        <path d="M230 460c0-11 9-20 20-20s20 9 20 20" fill="#0288D1" />
        <circle cx="288" cy="430" r="14" fill="#26A69A" />
        <path d="M268 460c0-11 9-20 20-20s20 9 20 20" fill="#008975" />
        <circle cx="326" cy="430" r="14" fill="#FFB300" />
        <path d="M306 460c0-11 9-20 20-20s20 9 20 20" fill="#FF8F00" />
      </g>
    </svg>
  );
}

function Login() {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [crmBootstrapping, setCrmBootstrapping] = useState(false);
  const [loginType, setLoginType] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginIdFocused, setLoginIdFocused] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const crmLoginStarted = useRef(false);

  useEffect(() => {
    const id = "eduok-login-fonts";
    if (document.getElementById(id)) return;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Outfit:wght@500;600;700;800&family=Source+Sans+3:wght@400;500;600;700&display=swap";
    document.head.appendChild(link);
  }, []);

  const apiUrl = useMemo(() => {
    return (
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      API_ENDPOINT
    );
  }, []);

  const handleLoginIdChange = useCallback((e) => {
    setLoginId(e.target.value.trim());
  }, []);

  const handlePasswordChange = useCallback((e) => {
    setPassword(e.target.value);
  }, []);

  const validateInput = useCallback(() => {
    if (!loginId.trim()) {
      myToast.notify_warning("Please enter your Login Id");
      return false;
    }
    if (!password) {
      myToast.notify_warning("Please enter your Password");
      return false;
    }
    return true;
  }, [loginId, password]);

  const handleSuccessfulLogin = useCallback((response) => {
    const { token, staff } = response;

    if (!token) {
      console.error("Login: Token missing in response");
      myToast.notify_warning("Invalid login response. Please try again.");
      return false;
    }

    if (!staff || !Array.isArray(staff) || !staff[0]) {
      console.error("Login: Invalid staff data in response");
      myToast.notify_warning("Invalid user data received. Please try again.");
      return false;
    }

    const staffData = staff[0];

    if (!staffData.school_code) {
      console.error("Login: school_code is missing in staff data");
      myToast.notify_warning(
        "School code is missing. Please contact administrator."
      );
      return false;
    }

    try {
      localStorage.setItem("token", token);
    } catch (error) {
      console.error("Login: Failed to save token", error);
      myToast.notify_warning("Failed to save session. Please try again.");
      return false;
    }

    const schoolCodeSaved = SessionManager.saveSchoolCode(
      staffData.school_code
    );
    if (!schoolCodeSaved) {
      console.error("Login: Failed to save school code");
      myToast.notify_warning("Failed to save session data. Please try again.");
      return false;
    }

    SessionManager.createStaffLoginSession(
      staffData.staff_id,
      staffData.staff_name,
      staffData.staff_phone,
      staffData.staff_email,
      staffData.password,
      staffData.staff_role,
      staffData.login_type,
      staffData.staff_image_path
    );

    setLoginType(staffData.login_type);
    setLoggedIn(true);
    return true;
  }, []);

  // Created By Cursor — shared login used by form submit and CRM App Access
  const performLogin = useCallback(
    async (userIdValue, passwordValue, options = {}) => {
      const { fromCrm = false } = options;
      const uid = String(userIdValue || "").trim();
      const pwd = String(passwordValue || "");

      if (!uid || !pwd) {
        myToast.notify_warning("Login Id and Password are required");
        return false;
      }

      setLoading(true);
      if (fromCrm) setCrmBootstrapping(true);

      try {
        const params = {
          user_id: uid,
          password: pwd,
          system_code: process.env.REACT_APP_SYSTEM_CODE,
          version_code: "1.1",
        };

        const response = await axios.get(apiUrl, { params });
        setLoading(false);
        setCrmBootstrapping(false);

        if (response?.data?.api_status === "OK") {
          return handleSuccessfulLogin(response.data);
        }

        const errorMessage =
          response?.data?.api_remark || "Login failed. Please try again.";
        myToast.notify_warning(errorMessage);
        return false;
      } catch (error) {
        setLoading(false);
        setCrmBootstrapping(false);
        console.error("Login error:", error);

        let errorMessage = "Network error. Please check your connection.";
        if (error.response) {
          errorMessage =
            error.response.data?.api_remark ||
            `Server error: ${error.response.status}`;
        } else if (error.request) {
          errorMessage = "No response from server. Please try again.";
        }

        myToast.notify_warning(errorMessage);
        return false;
      }
    },
    [apiUrl, handleSuccessfulLogin]
  );

  const handleLoginSubmit = useCallback(
    async (e) => {
      if (e) e.preventDefault();
      if (!validateInput()) return;
      await performLogin(loginId, password);
    },
    [loginId, password, validateInput, performLogin]
  );

  // Created By Cursor — CRM App Access auto-login on /mypage/login
  useEffect(() => {
    if (crmLoginStarted.current) return;
    const crm = readAndClearCrmLoginParams();
    if (!crm) return;

    crmLoginStarted.current = true;
    setLoginId(crm.user_id);
    setPassword(crm.password);
    performLogin(crm.user_id, crm.password, { fromCrm: true });
  }, [performLogin]);

  const getRedirectPath = useCallback(() => {
    if (!loggedIn) return null;

    if (
      loginType === LOGIN_TYPES.ADMIN ||
      loginType === LOGIN_TYPES.CLERK
    ) {
      return <Redirect to="/AdminMain" />;
    }

    if (
      loginType === LOGIN_TYPES.TEACHER ||
      loginType === LOGIN_TYPES.STUDENT
    ) {
      myToast.notify_warning(
        "Access Not Granted. Please use the mobile application."
      );
      return null;
    }

    return null;
  }, [loggedIn, loginType]);

  const redirect = getRedirectPath();
  if (redirect) return redirect;

  const inputBase = {
    width: "100%",
    height: 48,
    padding: "0 14px 0 44px",
    borderRadius: 10,
    border: "1.5px solid #d0d7e2",
    background: "#fff",
    fontFamily: '"Source Sans 3", sans-serif',
    fontSize: 15,
    color: "#1e293b",
    outline: "none",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        overflow: "hidden",
        fontFamily: '"Source Sans 3", sans-serif',
        color: "#0f172a",
        background: `linear-gradient(145deg, ${ACCENT_SOFT} 0%, #ffffff 42%, #e0f2fe 100%)`,
      }}
    >
      <style>{`
        @keyframes eduokLoginFadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes eduokLoginSpin {
          to { transform: rotate(360deg); }
        }
        @keyframes eduokLoginBrandIn {
          from { opacity: 0; transform: translateY(10px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes eduokIgFloatA {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        @keyframes eduokIgFloatB {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(10px); }
        }
        @keyframes eduokIgFloatC {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(-0.4deg); }
        }
        .eduok-ig-float-a { animation: eduokIgFloatA 6.5s ease-in-out infinite; }
        .eduok-ig-float-b { animation: eduokIgFloatB 7.5s ease-in-out infinite; }
        .eduok-ig-float-c { animation: eduokIgFloatC 5.8s ease-in-out infinite; }
        .eduok-ig-float-d { animation: eduokIgFloatA 8s ease-in-out infinite 0.6s; }
        .eduok-login-input:focus {
          border-color: ${ACCENT} !important;
          box-shadow: 0 0 0 3px ${ACCENT_SOFT} !important;
        }
        .eduok-login-btn:hover:not(:disabled) {
          background: ${ACCENT_DARK} !important;
          transform: translateY(-1px);
        }
        .eduok-login-btn:active:not(:disabled) {
          transform: translateY(0);
        }
        .eduok-register-btn:hover {
          background: ${ACCENT_SOFT} !important;
          color: ${ACCENT_DARK} !important;
          transform: translateY(-1px);
        }
        .eduok-login-link:hover {
          color: ${ACCENT_DARK} !important;
        }
        @media (max-width: 960px) {
          .eduok-login-shell {
            flex-direction: column !important;
            padding: 28px 16px !important;
          }
          .eduok-login-visual {
            width: 100% !important;
            max-width: 480px !important;
            padding: 8px 8px 0 !important;
          }
          .eduok-login-panel {
            width: 100% !important;
            max-width: 420px !important;
          }
          .eduok-login-brand {
            font-size: 28px !important;
          }
          .eduok-login-headline {
            font-size: 22px !important;
          }
        }
      `}</style>

      {/* Created By Cursor — CRM App Access signing-in overlay */}
      {crmBootstrapping && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(15, 23, 42, 0.45)",
            backdropFilter: "blur(4px)",
          }}
        >
          <div
            style={{
              minWidth: 260,
              padding: "28px 32px",
              borderRadius: 16,
              background: "#fff",
              boxShadow: "0 18px 40px rgba(1, 87, 155, 0.22)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 36,
                height: 36,
                margin: "0 auto 14px",
                borderRadius: "50%",
                border: `3px solid ${ACCENT_SOFT}`,
                borderTopColor: ACCENT,
                animation: "eduokLoginSpin 0.75s linear infinite",
              }}
            />
            <div
              style={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 800,
                fontSize: 16,
                color: "#01579B",
              }}
            >
              Signing in from CRM…
            </div>
            <div style={{ marginTop: 6, fontSize: 13, color: "#64748B", fontWeight: 600 }}>
              Please wait
            </div>
          </div>
        </div>
      )}

      {/* Soft grid / pattern atmosphere */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "radial-gradient(circle at 12% 18%, rgba(3,169,244,0.16) 0%, transparent 34%), radial-gradient(circle at 88% 78%, rgba(2,136,209,0.12) 0%, transparent 36%), linear-gradient(rgba(2,119,189,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(2,119,189,0.04) 1px, transparent 1px)",
          backgroundSize: "auto, auto, 42px 42px, 42px 42px",
          pointerEvents: "none",
        }}
      />

      <div
        className="eduok-login-shell"
        style={{
          position: "relative",
          zIndex: 1,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 48,
          padding: "40px 48px",
          boxSizing: "border-box",
        }}
      >
        {/* Left: brand + info graphics */}
        <div
          className="eduok-login-visual"
          style={{
            flex: "1 1 480px",
            maxWidth: 560,
            animation: "eduokLoginBrandIn 0.7s ease-out both",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              marginBottom: 16,
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL || ""}/images/logo.png`}
              alt="EduOK School Management System"
              style={{
                width: 64,
                height: 64,
                objectFit: "contain",
                borderRadius: 14,
                flexShrink: 0,
              }}
            />
            <div
              className="eduok-login-brand"
              style={{
                fontFamily: '"Outfit", sans-serif',
                fontSize: 36,
                fontWeight: 800,
                letterSpacing: "-0.02em",
                lineHeight: 1.15,
                color: ACCENT_DARK,
              }}
            >
              Edu<span style={{ color: ACCENT }}>OK</span> School Management
              System
            </div>
          </div>
          <p
            className="eduok-login-headline"
            style={{
              margin: "0 0 8px",
              fontFamily: '"Outfit", sans-serif',
              fontSize: 28,
              fontWeight: 700,
              color: "#0f172a",
              letterSpacing: "-0.02em",
              lineHeight: 1.2,
            }}
          >
            School operations, clearly in view.
          </p>
          <p
            style={{
              margin: "0 0 22px",
              fontSize: 15,
              color: "#475569",
              lineHeight: 1.5,
              maxWidth: 420,
            }}
          >
            Attendance, fees, exams, and student insights — one calm workspace
            for your campus team.
          </p>

          <LoginInfographic />
        </div>

        {/* Right: sign-in panel */}
        <div
          className="eduok-login-panel"
          style={{
            flex: "0 0 400px",
            width: 400,
            maxWidth: "100%",
            padding: "34px 32px 28px",
            borderRadius: 18,
            background: "rgba(255,255,255,0.94)",
            border: "1px solid #d7e6f4",
            boxShadow: "0 16px 40px rgba(1, 87, 155, 0.12)",
            animation: "eduokLoginFadeUp 0.55s ease-out both",
          }}
        >
          <div style={{ marginBottom: 22 }}>
            <p
              style={{
                margin: "0 0 6px",
                fontFamily: '"Outfit", sans-serif',
                fontSize: 22,
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              Sign in
            </p>
            <p style={{ margin: 0, fontSize: 14, color: "#64748b" }}>
              Use your staff credentials to continue.
            </p>
          </div>

          <form onSubmit={handleLoginSubmit} style={{ padding: 0 }}>
            <label
              htmlFor="loginId"
              style={{
                display: "block",
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                color: "#64748b",
                marginBottom: 7,
              }}
            >
              Login Id
            </label>
            <div style={{ position: "relative", marginBottom: 16 }}>
              <i
                className="fa fa-user"
                aria-hidden
                style={{
                  position: "absolute",
                  left: 15,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: loginIdFocused ? ACCENT : "#94a3b8",
                  fontSize: 15,
                  transition: "color 0.2s ease",
                }}
              />
              <input
                type="text"
                id="loginId"
                className="eduok-login-input"
                placeholder="Enter your login id"
                value={loginId}
                onChange={handleLoginIdChange}
                onFocus={() => setLoginIdFocused(true)}
                onBlur={() => setLoginIdFocused(false)}
                autoComplete="username"
                required
                disabled={loading}
                style={inputBase}
              />
            </div>

            <label
              htmlFor="password"
              style={{
                display: "block",
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                color: "#64748b",
                marginBottom: 7,
              }}
            >
              Password
            </label>
            <div style={{ position: "relative", marginBottom: 10 }}>
              <i
                className="fa fa-lock"
                aria-hidden
                style={{
                  position: "absolute",
                  left: 15,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: passwordFocused ? ACCENT : "#94a3b8",
                  fontSize: 15,
                  transition: "color 0.2s ease",
                }}
              />
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                className="eduok-login-input"
                placeholder="Enter your password"
                value={password}
                onChange={handlePasswordChange}
                onFocus={() => setPasswordFocused(true)}
                onBlur={() => setPasswordFocused(false)}
                autoComplete="current-password"
                required
                disabled={loading}
                style={{ ...inputBase, paddingRight: 46 }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                style={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "none",
                  background: "transparent",
                  color: "#94a3b8",
                  cursor: "pointer",
                  padding: 6,
                  fontSize: 15,
                }}
              >
                <i
                  className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                  aria-hidden
                />
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 22,
              }}
            >
              <Link
                to="./"
                className="eduok-login-link"
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: ACCENT,
                  textDecoration: "none",
                  transition: "color 0.2s ease",
                }}
              >
                Forgot password?
              </Link>
            </div>

            <button
              type="submit"
              id="createNewUser"
              className="eduok-login-btn"
              disabled={loading}
              style={{
                width: "100%",
                height: 50,
                border: "none",
                borderRadius: 10,
                background: ACCENT,
                color: "#fff",
                fontFamily: '"Outfit", sans-serif',
                fontSize: 16,
                fontWeight: 700,
                letterSpacing: "0.02em",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.75 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                transition:
                  "background 0.2s ease, transform 0.2s ease, opacity 0.2s ease",
              }}
            >
              {loading ? (
                <>
                  <i className="fa fa-spinner fa-spin" aria-hidden />
                  Signing in…
                </>
              ) : (
                <>
                  Sign in
                  <i className="fa fa-arrow-right" aria-hidden />
                </>
              )}
            </button>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                margin: "18px 0",
              }}
            >
              <div style={{ flex: 1, height: 1, background: "#e2e8f0" }} />
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#94a3b8",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                }}
              >
                or
              </span>
              <div style={{ flex: 1, height: 1, background: "#e2e8f0" }} />
            </div>

            <Link
              to="/Register"
              className="eduok-register-btn"
              style={{
                width: "100%",
                height: 50,
                borderRadius: 10,
                border: `1.5px solid ${ACCENT}`,
                background: "#fff",
                color: ACCENT_DARK,
                fontFamily: '"Outfit", sans-serif',
                fontSize: 16,
                fontWeight: 700,
                letterSpacing: "0.02em",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                boxSizing: "border-box",
                transition:
                  "background 0.2s ease, color 0.2s ease, transform 0.2s ease",
              }}
            >
              <i className="fa fa-user-plus" aria-hidden />
              Register
            </Link>
          </form>

          <p
            style={{
              margin: "22px 0 0",
              textAlign: "center",
              fontSize: 12,
              color: "#94a3b8",
            }}
          >
            School administration portal
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
